import { useMutation } from '@tanstack/react-query';
import * as service from '../services';
import { useOmnichannelStore } from '../store/ModuloOmnichannel.store';
import { GaugeChartsBody, GaugeChartsResponse } from '../types';

export const useOmnichannelGaugeCharts = () => {
  const { setOmnichannelState } = useOmnichannelStore();

  const successAction = (data: GaugeChartsResponse) => {
    setOmnichannelState('omnichannelGaugeChartsData', data);
  };

  const mutation = useMutation({
    mutationFn: (data: GaugeChartsBody) => service.getOmnichannelGaugeCharts(data),
    onSuccess: data => successAction(data.data),
  });

  return {
    omnichannelGaugeChartsLoading: mutation.isPending,
    handleGetOmnichannelGaugeCharts: mutation.mutateAsync,
  };
};
